<script setup lang="ts">
import { onMounted, defineProps, defineEmits } from "vue";
import { useRouter } from "vue-router";

const router = useRouter();

const emit = defineEmits([
  "update:title",
  "update:content",
  "update:status",
  "update:msg",
]);
const props = defineProps({
  type: {
    // Modal Type: Edit / Confirm
    type: String,
    required: false,
  },
  title: {
    type: String,
    required: true,
  },
  msg: {
    // Modal Alert Message
    type: String,
    required: true,
  },
  content: {
    // Modal Edit Content
    type: String,
    required: true,
  },

  status: {
    // Modal Open or Close
    type: Boolean,
    required: false,
  },
  childFunction: {
    // emit Function
    type: Function,
    required: false,
  },
});

const boolChange = () => {
  emit("update:status", false);
};

const refresh = () => {
  location.reload();
};



</script>

<template>
    <div id="downloadlModal" class="modal fixed p-center" :style="[props.status ? 'display: block': 'display: none']">
        <div class="modalTitle title-1 white flex j-between " :class="props.type !== 'Alert' ? 'bg-white-1':'bg-dark white-1'">{{ props.title }} <div class="icon-close sm pointer" :class="props.type !== 'Alert' ? 'white':''" @click="props.msg == 'refresh' ? refresh() : boolChange()"></div></div>
        <div class="modalContent bg-white-1 scroll">
            <div class="flex column-sm column a-center gap-20 p-40" v-if="props.type == 'Alert'">
                <img class="s-30" src="/icon-alert.svg" alt="">
                <p class="dark title-2 bold">{{ props.msg }}</p>
            </div>
            <div v-else>
                    <div v-if="props.content == 'CreateOrganization'">
                        <div class=" flex column mb-20">
                            <label class="label bold" for="orgname">Organization Name <span class="alert">*</span></label>
                            <input class="input" type="text" placeholder="Organization Name" id="orgname">

                        </div>
                        <div class=" flex column">
                            <h3 class="label bold">The players you want to invite <span class="alert">*</span></h3>
                            <div  class="i-flex a-center gap-5 scroll mt-20 mb-20" >
                                <div class="tag av br-pr-200"><img src="/avatar-default.png" alt="">Kathy<span class="icon-close bg-pr white-1 circle sm"></span></div>
                                <div class="tag av br-pr-200"><img src="/avatar-default.png" alt="">Jani<span class="icon-close bg-pr white-1 circle sm"></span></div>
                                <div class="tag av br-pr-200"><img src="/avatar-default.png" alt="">Amy<span class="icon-close bg-pr white-1 circle sm"></span></div>
            
                            </div>
                            <div class="flex gap-20 rel mb-5" style="width: 100%">
                                <label for="debatersList" class="inputBox i-flex j-center column" style="width: 100%">
                                
                                    <input id="debatersList"  type="text" style="width: 100%" >
                
                                </label>
                                <div id="memberDropdown" class="memberDropdown bg-white abs scroll active" >
                                    <div  class="grid gap-5">
            
                                            <div class="memberItem flex a-center gap-5"><img class="avatar-xs" src="/avatar-default.png" alt="">Kathy</div>
                                            <div class="memberItem flex a-center gap-5"><img class="avatar-xs" src="/avatar-default.png" alt="">Kitty</div>
                                            <div class="memberItem flex a-center gap-5"><img class="avatar-xs" src="/avatar-default.png" alt="">Ken</div>
                                            <div class="memberItem flex a-center gap-5"><img class="avatar-xs" src="/avatar-default.png" alt="">Kevin</div>
            
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="props.content == 'EditOrganization'">
                        <div class=" flex column mb-20">
                            <label class="label bold" for="orgname">Organization Name <span class="alert">*</span></label>
                            <input class="input" type="text" placeholder="Organization Name" id="orgname" value="Princeton">
                            
                        </div>
                        <div class=" flex column">
                            <h3 class="label bold">Organization Admins:</h3>
                            <div  class="i-flex a-center gap-5 scroll mt-20 mb-20" >
                                <div class="tag av br-pr-200"><img src="/avatar-default.png" alt="">Kathy<span class="icon-close bg-pr white-1 circle sm"></span></div>
                                <div class="tag av br-pr-200"><img src="/avatar-default.png" alt="">Jani<span class="icon-close bg-pr white-1 circle sm"></span></div>
                                <div class="tag av br-pr-200"><img src="/avatar-default.png" alt="">Amy<span class="icon-close bg-pr white-1 circle sm"></span></div>
                                
                            </div>
                            <div class="flex column mb-20">
                                <label class="label bold" for="addadmin">Add a new admin</label>
                                <input class="input" type="text" placeholder="Search Email" id="addadmin">
                                
                            </div>
                        </div>
                    </div>
                    <div v-if="props.content == 'OrganizationDetails'">
                        <div class=" flex a-center gap-10 mb-20">
                            <label class="label bold black-4">Org. Name</label>
                            <p class="title-1">Princeton</p>
                        </div>
                        <div class=" flex a-center gap-10 mb-20">
                            <label class="label bold black-4">Org. Admins</label>
                            <div class="tag av br-pr-200"><img src="/avatar-default.png" alt="">Kathy<span class="icon-close bg-pr white-1 circle sm"></span></div>
                            <div class="tag av br-pr-200"><img src="/avatar-default.png" alt="">Jani<span class="icon-close bg-pr white-1 circle sm"></span></div>
                            
                        </div>
                        <div class=" flex a-center gap-10 mb-20">
                            <label class="label bold black-4">Groups List</label>
                            <p class="title-1">Honors</p>
                            <p class="title-1">AP</p>
                            <p class="title-1">GT</p>
                        </div>
                        <div class=" flex a-center gap-10 mb-20">
                            <label class="label bold black-4">Group Manager</label>
                            <div class="tag av br-pr-200"><img src="/avatar-default.png" alt="">Kathy<span class="icon-close bg-pr white-1 circle sm"></span></div>
                            <div class="tag av br-pr-200"><img src="/avatar-default.png" alt="">Jani<span class="icon-close bg-pr white-1 circle sm"></span></div>
                            
                        </div>
                        <div class=" flex a-center gap-10 mb-20">
                            <label class="label bold black-4">Members List</label>
                            <div class="tag bg-pr white-1">198 users</div>
                        </div>
                        
                    </div>
                    <div v-if="props.content == 'CreateGroup'">
                        <div class=" flex column mb-20">
                            <label class="label bold" for="groupname">Group Name <span class="alert">*</span></label>
                            <input class="input" type="text" placeholder="Group Name" id="groupname">
                            
                        </div>
                        
                    </div>
                    <div v-if="props.content == 'EditGroup'">
                        <div class=" flex column mb-20">
                            <label class="label bold" for="groupname">Group Name <span class="alert">*</span></label>
                            <input class="input" type="text" placeholder="Group Name" id="groupname">
                            
                        </div>
                        <div class=" flex column mb-20">
                            <h3 class="label bold">Group Members:</h3>
                            <div  class="i-flex a-center gap-5 mt-20 mb-20" >
                                
                                <div class="tag bg-pr-200 white">200 users</div><span class="icon-search pointer"></span>  
                            </div>
                            
                        </div>
                        <div class="flex column mb-20">
                            <label class="label bold" for="addmember">add new member to the group</label>
                            <input class="input" type="text" placeholder="Search Email" id="addmember">
                            
                        </div>
                        
                    </div>
                    <div v-if="props.content == 'CreateMember'">
                        <p class="title-2 mb-20">Add the user email you want to invite to your group</p>
                        <div class=" flex column">
                            <h3 class="label bold">The members you want to invite <span class="alert">*</span></h3>
                            <div  class="i-flex a-center gap-5 scroll mt-20 mb-20" >
                                <div class="tag av br-pr-200"><img src="/avatar-default.png" alt="">Kathy<span class="icon-close bg-pr white-1 circle sm"></span></div>
                                <div class="tag av br-pr-200"><img src="/avatar-default.png" alt="">Jani<span class="icon-close bg-pr white-1 circle sm"></span></div>
                                <div class="tag av br-pr-200"><img src="/avatar-default.png" alt="">Amy<span class="icon-close bg-pr white-1 circle sm"></span></div>
                                
                            </div>
                            <div class="flex gap-20 rel mb-5" style="width: 100%">
                                <label for="debatersList" class="inputBox i-flex j-center column" style="width: 100%">
                                  
                                    <input id="debatersList"  type="text" style="width: 100%" >
                
                                </label>
                             
                            </div>
                         </div>
                        
                         <div class=" flex column">
                             <h3 class="label bold">Group <span class="alert">*</span></h3>
                             <select required class="select" name="group" id="group">
                                 <option value="AP">AP</option>
                                 <option value="Honors">Honors</option>
                                 
                                </select>
                            </div>
                            
                        </div>
                        
                        
                    <div v-if="props.content == 'FilterMember'">
                        <p class="title-2 mb-20">Groups</p>
                        <div class=" flex gap-10 mb-20">
                            <label class="filterItem btn chbox" for="AP">AP</label>
                            <label class="filterItem btn chbox" for="Honors">Honors</label>
                            <label class="filterItem btn chbox" for="GT">GT</label>
            
                        </div>
                       
                        
                    </div>
            </div>
            
        </div>
        <div class="modalFooter bg-white-1">
            <div class="t-right">
            
                
                <div class="flex gap-5 j-end" v-if="props.type == 'Alert'">
                    <button class="btn-sm bg-dark" @click="boolChange()">Cancel</button>
                    <!-- <button class="btn-sm bg-black-4" @click="props.childFunction">Submit</button> -->
                </div>
                <div class="flex gap-5 j-end" v-else-if="props.type == 'Edit'">
                    <button class="btn-sm bg-black-4" @click="boolChange()">Cancel</button>
                    <!-- <button class="btn-sm bg-black-2" @click="props.childFunction">Save</button> -->
                </div>
                <div class="flex gap-5 j-end" v-else-if="props.type == 'Filter'">
                    <button class="btn-sm bg-black-4" >Clean</button>
                    <button class="btn-sm bg-black-2" @click="boolChange()">Close</button>
                </div>
                <div class="flex gap-5 j-end" v-else>
                    <button class="btn-sm bg-black-2" @click="boolChange()">Close</button>
                </div>


            </div>
        </div>
    </div>

    <div class="loading fixed flex a-center j-center"  :class="props.status? 'active': ''">
        
    </div>
</template>
<style scoped>
@import "../../assets/css_lib/themimir.css";
</style>